import React, { useMemo } from 'react';
import { useTranslation } from '@lib/useTypedTranslation';

import { formatValue } from '../../../../../../components/data-table/dataFormatters';
import { ITableColumn } from '../../../../../../components/data-table/types';
import { getDeviceProcessHangsSummary } from '../../../../../../services/core/devicePerformance';
import { AnomalySectionProps } from './index';
import { ProcessEventsSection } from './processEventsSection';

export function ProcessHangsSection(props: AnomalySectionProps) {
  const { t } = useTranslation(['anomalyDetectionBeta']);

  // width: '1%' (see useProcessEventsRawColumns.tsx's own comment) - a fixed-shape value, not a
  // variable-length identifier, so it shouldn't absorb the Raw Data table's leftover space.
  const eventColumns: ITableColumn[] = useMemo(() => [
    { id: 'reason', title: t('REASON', { ns: 'anomalyDetectionBeta' }), dataPath: 'processHangInfo.type', sortable: true, processor: formatValue, width: '1%' }
  ], [t]);

  return (
    <ProcessEventsSection
      {...props}
      eventName="processHung"
      rawTableName="deviceAnomalyProcessHangsRaw"
      summaryTableName="deviceAnomalyProcessHangsSummary"
      getSummary={getDeviceProcessHangsSummary}
      titleKey="PROCESS_HANGS_FOR_RANGE"
      rawStatusTextKey="PROCESS_HANG_RESULT"
      countColumnTitleKey="NUMBER_OF_HANGS"
      eventColumns={eventColumns}
      dataId="device-anomaly-examination-process-hangs"
    />
  );
}
